import { apiRequest, buildQuery } from "@/apis/client";
import type {
  // UsageAppItem,
  UsageAppsListResponse,
  UsagePaginationQuery,
  UsageSectionDataResponse,
  // UsageUserDetail,
  UsageUsersListResponse,
  UsageUsersQuery,
} from "@/apis/types";

export const usageApi = {
  listApps(): Promise<UsageAppsListResponse> {
    return apiRequest<UsageAppsListResponse>("/admin/usage/apps");
  },


  listUsers(appId: string, params: UsageUsersQuery = {}): Promise<any> {
    const query = buildQuery({
      page: params.page ?? 1,
      limit: params.limit ?? 100,
      search: params.search,

    });
    return apiRequest<UsageUsersListResponse>(
      `/admin/usage/${encodeURIComponent(appId)}/api/usage/users${query}`
    );
  },


  getCompanies(
    appId: string,
    params: UsagePaginationQuery = {}
  ): Promise<any> {
    const query = buildQuery({
      page: params.page ?? 1,
      limit: params.limit ?? 100,
    });
    return apiRequest<UsageSectionDataResponse>(
      `/admin/usage/${encodeURIComponent(appId)}/api/usage/all-companies${query}`
    );
  },
  getSimulations(
    appId: string,
    params: UsagePaginationQuery = {}
  ): Promise<any> {
    const query = buildQuery({
      page: params.page ?? 1,
      limit: params.limit ?? 100,
    });
    return apiRequest<UsageSectionDataResponse>(
      `/admin/usage/${encodeURIComponent(appId)}/api/usage/all-simulations${query}`
    );
  },

};
